function treeData(source, id, parentId, children) {
  let cloneData = JSON.parse(JSON.stringify(source));
  return cloneData.filter((father) => {
    let branchArr = cloneData.filter((child) => father[id] == child[parentId]);
    branchArr.length > 0 ? (father[children] = branchArr) : '';
    return father[parentId] == 0; // 如果第一层不是parentId=0，请自行修改
  });
}
function toTree(data) {
  var result = [];
  if (!Array.isArray(data)) {
    return result;
  }
  data.forEach(function(item) {
    delete item.children;
  });
  var map = {};
  data.forEach(function(item) {
    map[item.pid] = item;
  });
  data.forEach(function(item) {
    var parent = map[item.ppid];
    if (parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      result.push(item);
    }
  });
  return result;
}
function uniqueArray(array, key) {
  var result = [array[1]];
  for (var i = 1; i < array.length; i++) {
    var item = array[i];
    var repeat = false;
    for (var j = 0; j < result.length; j++) {
      if (item[key] == result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}
export default {
  namespaced: true,
  state: {
    log: [],
    processLogTree: [],
    processLog: [],
    fileLog: [],
    interceptLog: [],
    dnsLog: [],
    modalLog: [],
    tcpLog: [],
    selectPro: [],
    refreshFn: false,
    refreshFn2: false,
  },
  mutations: {
    resetLog(state) {
      state.log = [];
      state.processLog = [];
      state.fileLog = [];
      state.interceptLog = [];
      state.dnsLog = [];
      state.modalLog = [];
      state.tcpLog = [];
    },
    setLog(state, data) {
      state.log.push(data[0]);
      if (data[0].iid == 1) {
        let index = state.processLog.findIndex(
          (val) => val.pid == data[0].pid && val.ppid == data[0].ppid
        );
        if (index == -1) {
          state.processLog.push(data[0]);
        }
        if (data[0].subid == 2) {
          let index = state.processLog.findIndex(
            (val) => val.pid == data[0].pid && val.ppid == data[0].ppid
          );
          if (index != -1) {
            state.processLog[index].destoryTime = data[0].time;
          } else {
            data[0].destoryTime = data[0].time;
            data[0].time = '';
            state.processLog.push(data[0]);
          }
        }

        let data2 = treeData(state.processLog, 'pid', 'ppid', 'children');
        state.processLogTree = data2;
      } else if (data[0].iid == 2) {
        state.modalLog.push(data[0]);
      } else if (data[0].iid == 3) {
        if (data[0].subid == 6) {
          state.dnsLog.push(data[0]);
        } else {
          state.tcpLog.push(data[0]);
        }
      } else if (data[0].iid == 5) {
        state.interceptLog.push(data[0]);
      } else if (data[0].iid == 6) {
        state.interceptLog.push(data[0]);
      } else if (data[0].iid == 7) {
        state.fileLog.push(data[0]);
      }
    },
    addSelectPro(state, data) {
      let index = state.selectPro.findIndex((val) => val.xid === data.xid);
      if (index == -1) {
        state.selectPro.push(data);
      }
    },
    delSelectPro(state, data) {
      let index = state.selectPro.findIndex((val) => val.xid === data.xid);
      if (index != -1) {
        state.selectPro.splice(index, 1);
      }
    },
    resetSelectPro(state, data) {
      state.selectPro = [];
    },
    setRefreshFn(state, data) {
      state.refreshFn = !state.refreshFn;
    },
    setRefreshFn2(state, data) {
      state.refreshFn2 = !state.refreshFn2;
    },
  },
  actions: {
    actionSetRefreshFn2({ commit }, data) {
      commit('setRefreshFn2', data);
    },
    actionSetRefreshFn({ commit }, data) {
      commit('setRefreshFn', data);
    },
    actionSetRule({ commit }, data) {
      commit('setLog', data);
    },
    actionResetLog({ commit }) {
      commit('resetLog');
    },
    actionAddSelectPro({ commit }, data) {
      commit('addSelectPro', data);
    },
    actionDelSelectPro({ commit }, data) {
      commit('delSelectPro', data);
    },
    actionResetSelectPro({ commit }, data) {
      commit('resetSelectPro', data);
    },
  },
};
